import { LogOut, Settings } from "lucide-react";
import { Link, useNavigate } from "react-router";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLogout, useMe } from "@/lib/auth";

export function UserMenu() {
	const me = useMe();
	const logout = useLogout();
	const navigate = useNavigate();
	const email = me.data?.email ?? "";
	const name = me.data?.display_name || email;
	const initial = (name[0] ?? "?").toUpperCase();

	function onLogout() {
		logout.mutate(undefined, {
			onError: () => toast.error("Could not reach the server. You are signed out on this device."),
			onSettled: () => navigate("/login", { replace: true }),
		});
	}

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="icon" className="size-11 md:size-9" aria-label="User menu">
					<span className="bg-primary text-primary-foreground flex size-7 items-center justify-center rounded-full text-xs font-semibold">
						{initial}
					</span>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="w-56">
				{email && (
					<>
						<DropdownMenuLabel className="truncate font-normal">
							<div className="truncate font-medium">{name}</div>
							{name !== email && (
								<div className="text-muted-foreground truncate text-xs">{email}</div>
							)}
						</DropdownMenuLabel>
						<DropdownMenuSeparator />
					</>
				)}
				<DropdownMenuItem asChild>
					<Link to="/settings">
						<Settings /> Settings
					</Link>
				</DropdownMenuItem>
				<DropdownMenuItem onSelect={onLogout} disabled={logout.isPending}>
					<LogOut /> Log out
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
